(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["emuiDiagnostics"] = factory();
	else
		root["emuiDiagnostics"] = factory();
})(globalThis, () => {
return 